import React from "react";
import { useState } from "react";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import MainSidebar from "../Mainsidebar";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import axios from "axios";
import "../../Style/AddProduct.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { path_url } from "../../Config/config";

const AddProduct = () => {
  // Strips currency symbols, commas, and percent signs so text like
  // "₹2,499" or "18% GST" can be validated/stored as a plain number.
  const toNumber = (value) => {
    if (typeof value !== "string") return value;
    const cleaned = value.replace(/[^0-9.-]/g, "");
    return cleaned === "" ? undefined : Number(cleaned);
  };

  const productSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    retailPrice: Yup.number()
      .transform((_, originalValue) => toNumber(originalValue))
      .typeError("Retail Price must be a number")
      .required("Required"),
    buyPrice: Yup.number()
      .transform((_, originalValue) => toNumber(originalValue))
      .typeError("Buy Price must be a number")
      .nullable(),
    tax1: Yup.number()
      .transform((_, originalValue) => toNumber(originalValue))
      .typeError("Tax1 must be a number")
      .nullable(),
    tax2: Yup.number()
      .transform((_, originalValue) => toNumber(originalValue))
      .typeError("Tax2 must be a number")
      .nullable(),
    productCode: Yup.string().required("Required"),
  });

  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  const options = [
    { value: "ABC Distributors", label: "ABC Distributors" },
    { value: "Global Traders", label: "Global Traders" },
    { value: "Prime Suppliers Co.", label: "Prime Suppliers Co." },
  ];

  const options1 = [
    { value: "Sony", label: "Sony" },
    { value: "Samsung", label: "Samsung" },
    { value: "boAt", label: "boAt" },
  ];

  const options2 = [
    { value: "Electronics", label: "Electronics" },
    { value: "Accessories", label: "Accessories" },
    { value: "Home Appliances", label: "Home Appliances" },
  ];

  const options3 = [
    { value: "Featured", label: "Featured" },
    { value: "New Arrival", label: "New Arrival" },
    { value: "Best Seller", label: "Best Seller" },
  ];

  return (
    <>
      <div className="con1 d-flex">
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />

          <div className="product">
            <Formik
              initialValues={{
                name: "",
                description: "",
                retailPrice: "",
                tax1: "",
                tax2: "",
                supplier: "",
                brand: "",
                tag: "",
                category: "",
                buyPrice: "",
                productCode: "",
                barCode: "",
                internalNotes: "",
                temporarilyDeactive: false,
              }}
              validationSchema={productSchema}
              onSubmit={async (values, { setSubmitting, resetForm }) => {
                try {
                  const token = localStorage.getItem("accessToken");

                  // Send clean numeric values to the API — the ₹/% are
                  // only for display, never part of the stored value.
                  const submitPayload = {
                    ...values,
                    retailPrice: toNumber(values.retailPrice),
                    buyPrice: toNumber(values.buyPrice),
                    tax1: toNumber(values.tax1),
                    tax2: toNumber(values.tax2),
                  };

                  const response = await axios.post(
                    `${path_url}/product`,
                    submitPayload,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                      },
                    },
                  );

                  if (
                    response &&
                    (response.status === 200 || response.status === 201)
                  ) {
                    toast.success("Product added successfully");
                    resetForm();
                  } else {
                    toast.error("Failed to add product");
                  }
                } catch (error) {
                  console.log(error);
                  toast.error("Failed to save product. Please try again.");
                } finally {
                  setSubmitting(false);
                }
              }}
            >
              {(formik) => (
                <form onSubmit={formik.handleSubmit} className="product-card">
                  <div className="product-card-header">
                    <h2>Add Product</h2>
                  </div>

                  <div className="product-grid">
                    {/* LEFT COLUMN */}
                    <div>
                      <div className="product-field">
                        <label>
                          Name<span className="product-required">*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          placeholder="e.g. Wireless Headphones"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.name}
                        />
                        {formik.touched.name && formik.errors.name && (
                          <span className="product-error">
                            {formik.errors.name}
                          </span>
                        )}
                      </div>

                      <div className="product-field">
                        <label>
                          Retail Price
                          <span className="product-required">*</span>
                        </label>
                        <div className="product-input-with-prefix">
                          <span className="product-prefix">₹</span>
                          <input
                            type="number"
                            name="retailPrice"
                            placeholder="0.00"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.retailPrice}
                          />
                        </div>
                        {formik.touched.retailPrice &&
                          formik.errors.retailPrice && (
                            <span className="product-error">
                              {formik.errors.retailPrice}
                            </span>
                          )}
                      </div>

                      <div className="product-field">
                        <label>Supplier</label>
                        <Field
                          as="select"
                          name="supplier"
                          className="product-select"
                        >
                          <option value="">Select Supplier</option>
                          {options.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Field>
                      </div>

                      <div className="product-field">
                        <label>
                          Product Code
                          <span className="product-required">*</span>
                        </label>
                        <input
                          type="text"
                          name="productCode"
                          placeholder="e.g. WH-BT-001"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.productCode}
                        />
                        {formik.touched.productCode &&
                          formik.errors.productCode && (
                            <span className="product-error">
                              {formik.errors.productCode}
                            </span>
                          )}
                      </div>

                      <div className="product-field">
                        <label>Brand</label>
                        <Field
                          as="select"
                          name="brand"
                          className="product-select"
                        >
                          <option value="">Select Brand</option>
                          {options1.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Field>
                      </div>

                      <div className="product-field">
                        <label>Tags</label>
                        <Field
                          as="select"
                          name="tag"
                          className="product-select"
                        >
                          <option value="">Select Tag</option>
                          {options3.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Field>
                      </div>

                      <div className="product-checkbox-row">
                        <input
                          type="checkbox"
                          id="temporarilyDeactive"
                          name="temporarilyDeactive"
                          checked={formik.values.temporarilyDeactive}
                          onChange={formik.handleChange}
                        />
                        <label htmlFor="temporarilyDeactive">
                          Temporarily Deactive
                        </label>
                      </div>
                    </div>

                    {/* RIGHT COLUMN */}
                    <div>
                      <div className="product-field">
                        <label>Description</label>
                        <input
                          type="text"
                          name="description"
                          placeholder="Short product description"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.description}
                        />
                      </div>

                      <div className="product-tax-row">
                        <div className="product-field product-tax-field">
                          <label>Tax1</label>
                          <div className="product-input-with-suffix">
                            <input
                              type="number"
                              name="tax1"
                              placeholder="0"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.tax1 ?? ""}
                            />
                            <span className="product-suffix">%</span>
                          </div>
                          {formik.touched.tax1 && formik.errors.tax1 && (
                            <span className="product-error">
                              {formik.errors.tax1}
                            </span>
                          )}
                        </div>
                        <div className="product-field product-tax-field">
                          <label>Tax2</label>
                          <div className="product-input-with-suffix">
                            <input
                              type="number"
                              name="tax2"
                              placeholder="0"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.tax2 ?? ""}
                            />
                            <span className="product-suffix">%</span>
                          </div>
                          {formik.touched.tax2 && formik.errors.tax2 && (
                            <span className="product-error">
                              {formik.errors.tax2}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="product-field">
                        <label>Buy Price</label>
                        <div className="product-input-with-prefix">
                          <span className="product-prefix">₹</span>
                          <input
                            type="number"
                            name="buyPrice"
                            placeholder="0.00"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.buyPrice}
                          />
                        </div>
                        {formik.touched.buyPrice &&
                          formik.errors.buyPrice && (
                            <span className="product-error">
                              {formik.errors.buyPrice}
                            </span>
                          )}
                      </div>

                      <div className="product-field">
                        <label>Bar Code</label>
                        <input
                          type="text"
                          name="barCode"
                          placeholder="e.g. 8901234567890"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.barCode}
                        />
                      </div>

                      <div className="product-field">
                        <label>Category</label>
                        <Field
                          as="select"
                          name="category"
                          className="product-select"
                        >
                          <option value="">Select Category</option>
                          {options2.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Field>
                      </div>

                      <div className="product-field">
                        <label>Internal Notes</label>
                        <textarea
                          name="internalNotes"
                          placeholder="Notes"
                          rows={3}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.internalNotes}
                        />
                      </div>
                    </div>

                    <div className="product-actions">
                      <button
                        type="button"
                        className="product-btn product-btn-cancel"
                        onClick={() => formik.resetForm()}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="product-btn product-btn-save"
                        disabled={formik.isSubmitting}
                      >
                        {formik.isSubmitting ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>

          <UserFooter />
        </div>
      </div>
    </>
  );
};

export default AddProduct;